const STATES = [
  { kod_negeri_id: '01', value: 'Johor', text: 'Johor' },
  { kod_negeri_id: '02', value: 'Kedah', text: 'Kedah' },
  { kod_negeri_id: '03', value: 'Kelantan', text: 'Kelantan' },
  { kod_negeri_id: '14', value: 'Kuala Lumpur', text: 'Wilayah Persekutuan Kuala Lumpur' },
  { kod_negeri_id: '15', value: 'Labuan', text: 'Wilayah Persekutuan Labuan' },
  { kod_negeri_id: '04', value: 'Malacca', text: 'Melaka' },
  { kod_negeri_id: '05', value: 'Negeri Sembilan', text: 'Negeri Sembilan' },
  { kod_negeri_id: '06', value: 'Pahang', text: 'Pahang' },
  { kod_negeri_id: '07', value: 'Penang', text: 'Pulau Pinang' },
  { kod_negeri_id: '08', value: 'Perak', text: 'Perak' },
  { kod_negeri_id: '09', value: 'Perlis', text: 'Perlis' },
  { kod_negeri_id: '16', value: 'Putrajaya', text: 'Wilayah Persekutuan Putrajaya' },
  { kod_negeri_id: '12', value: 'Sabah', text: 'Sabah' },
  { kod_negeri_id: '13', value: 'Sarawak', text: 'Sarawak' },
  { kod_negeri_id: '10', value: 'Selangor', text: 'Selangor' },
  { kod_negeri_id: '11', value: 'Terengganu', text: 'Terengganu' },
];

export default STATES;



// WEBPACK FOOTER //
// ./src/constants/states.js